import React, { useState, useMemo } from 'react';
import Grid from '../components/Grid';
import Pagination from '../components/Pagination';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Reports1 = () => {
  const [selectedSite, setSelectedSite] = useState('');
  const [selectedRMS, setSelectedRMS] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [selectedRows, setSelectedRows] = useState([]);

  // RMS Report Data
  const rmsReportData = [
    { id: 1, date: 'Jun 10 2025', supplier: 'KKD', site: 'PT001', dcNo: '746', grade: 'M30', supervisor: 'Mani', vehicleNumber: 'TN3383', transport: 'Linga' },
    { id: 2, date: 'Jun 09 2025', supplier: 'KKD', site: 'PT001', dcNo: '747', grade: 'M30', supervisor: 'Hanumanth', vehicleNumber: 'TN3383', transport: 'Linga' },
    { id: 3, date: 'Jun 03 2025', supplier: 'KKD', site: 'PT001', dcNo: '749', grade: '25.46', supervisor: 'Hanumanth', vehicleNumber: 'TN8745', transport: 'Linga' },
    { id: 4, date: 'Jun 03 2025', supplier: 'KKD', site: 'PT001', dcNo: '747', grade: 'N/D', supervisor: 'Mohan,Hanumanth', vehicleNumber: 'TN1596', transport: 'Linga' },
    { id: 5, date: 'Jun 03 2025', supplier: 'KKD', site: 'PT001', dcNo: '749', grade: 'N/D', supervisor: 'Hanumanth', vehicleNumber: 'TN1452', transport: 'MM.E Movers' },
    { id: 6, date: 'Jun 02 2025', supplier: 'ABC Corp', site: 'PT002', dcNo: '750', grade: 'M25', supervisor: 'Kumar', vehicleNumber: 'TN1234', transport: 'Express' },
    { id: 7, date: 'Jun 02 2025', supplier: 'ABC Corp', site: 'PT002', dcNo: '751', grade: 'M20', supervisor: 'Ravi', vehicleNumber: 'TN5678', transport: 'Express' },
    { id: 8, date: 'Jun 01 2025', supplier: 'XYZ Ltd', site: 'PT003', dcNo: '752', grade: 'M35', supervisor: 'Suresh', vehicleNumber: 'TN9012', transport: 'Fast Track' },
    { id: 9, date: 'Jun 01 2025', supplier: 'XYZ Ltd', site: 'PT003', dcNo: '753', grade: 'M30', supervisor: 'Rajesh', vehicleNumber: 'TN3456', transport: 'Fast Track' },
    { id: 10, date: 'May 31 2025', supplier: 'DEF Inc', site: 'PT001', dcNo: '754', grade: 'M25', supervisor: 'Mani', vehicleNumber: 'TN7890', transport: 'Linga' },
    { id: 11, date: 'May 31 2025', supplier: 'DEF Inc', site: 'PT001', dcNo: '755', grade: 'M20', supervisor: 'Hanumanth', vehicleNumber: 'TN2468', transport: 'Linga' }
  ];

  const siteOptions = [

    { value: 'PT001', label: 'PT001' },
    { value: 'PT002', label: 'PT002' },
    { value: 'PT003', label: 'PT003' }
  ];

  const rmsOptions = [
    { value: '', label: 'Sites Details' },
    { value: 'PT001', label: 'Employee Details' },
    { value: 'PT002', label: 'Transport Details' },
    { value: 'PT003', label: 'Vendor Details' }
  ];

  // Filter data based on selected site
  const filteredData = useMemo(() => {
    if (!selectedSite) return rmsReportData;
    return rmsReportData.filter(item => item.site === selectedSite);
  }, [selectedSite, rmsReportData]);

  // Pagination logic for report data
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedRows(paginatedData.map(item => item.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id, checked) => {
    if (checked) {
      setSelectedRows(prev => [...prev, id]);
    } else {
      setSelectedRows(prev => prev.filter(rowId => rowId !== id));
    }
  };

  const generateReport = () => {
    // Generate report based on selected filters
    console.log('Generating report with:', { selectedSite, selectedRMS, selectedRows });
  };

  // Download functions
  const downloadPDF = async () => {
    // Dynamically import autoTable
    const autoTable = (await import('jspdf-autotable')).default;
    
    const doc = new jsPDF();
    const currentDate = new Date().toLocaleDateString();
    
    // Add title
    doc.setFontSize(20);
    doc.text('RMS Report', 14, 22);
    
    // Add date and filters
    doc.setFontSize(10);
    doc.text(`Generated on: ${currentDate}`, 14, 30);
    doc.text(`Site: ${selectedSite || 'All Sites'}`, 14, 36);
    doc.text(`RMS Type: ${selectedRMS || 'All RMS Details'}`, 14, 42);
    
    // Add table
    const headers = ['Date', 'Supplier', 'Site', 'DC No', 'Grade', 'Supervisor', 'Vehicle Number', 'Transport'];
    const tableData = filteredData.map(item => [
      item.date,
      item.supplier,
      item.site,
      item.dcNo,
      item.grade,
      item.supervisor,
      item.vehicleNumber,
      item.transport
    ]);
    
    // Use autoTable for better formatting
    autoTable(doc, {
      head: [headers],
      body: tableData,
      startY: 50,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [0, 150, 136] },
      margin: { top: 20 }
    });

    doc.save(`RMS_Report_${currentDate.replace(/\//g, '-')}.pdf`);
  };

  const downloadExcel = () => {
    const currentDate = new Date().toLocaleDateString();
    
    // Prepare data for Excel
    const headers = ['Date', 'Supplier', 'Site', 'DC No', 'Grade', 'Supervisor', 'Vehicle Number', 'Transport'];
    const tableData = filteredData.map(item => [
      item.date,
      item.supplier,
      item.site,
      item.dcNo,
      item.grade,
      item.supervisor,
      item.vehicleNumber,
      item.transport
    ]);

    // Create workbook
    const wb = XLSX.utils.book_new();
    
    // Add data sheet
    const dataWS = XLSX.utils.aoa_to_sheet([headers, ...tableData]);
    XLSX.utils.book_append_sheet(wb, dataWS, 'RMS Data');
    
    // Save file
    const fileName = `RMS_Report_${currentDate.replace(/\//g, '-')}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900 font-poppins">Report</h1>
        <div className="flex items-center space-x-4">
          {/* Site Details Dropdown */}
          <select
            value={selectedRMS}
            onChange={(e) => setSelectedRMS(e.target.value)}
            className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md"
          >
            {rmsOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        
        </div>
      </div>

      {/* RMS Details Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            
            <select
              value={selectedSite}
              onChange={(e) => setSelectedSite(e.target.value)}
              className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md"
            >
              {siteOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={downloadPDF}
            className="flex items-center px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Download PDF
          </button>
          <button
            onClick={downloadExcel}
            className="flex items-center px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Download Excel
          </button>
         
        </div>
      </div>

      {/* Report Table */}
      <div className="bg-white shadow rounded-lg">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <input
                    type="checkbox"
                    checked={selectedRows.length === paginatedData.length && paginatedData.length > 0}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    className="rounded border-gray-300 text-primary focus:ring-primary"
                  />
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <div className="flex items-center">
                    Date
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                    </svg>
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <div className="flex items-center">
                    Supplier
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                    </svg>
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <div className="flex items-center">
                    Site
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                    </svg>
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <div className="flex items-center">
                    DC No
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                    </svg>
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <div className="flex items-center">
                    Grade
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                    </svg>
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <div className="flex items-center">
                    Supervisor
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                    </svg>
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <div className="flex items-center">
                    Vehicle Number
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                    </svg>
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium  tracking-wider">
                  <div className="flex items-center">
                    Transport
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                    </svg>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {paginatedData.map((item) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(item.id)}
                      onChange={(e) => handleSelectRow(item.id, e.target.checked)}
                      className="rounded border-gray-300 text-primary focus:ring-primary"
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.date}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.supplier}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.site}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.dcNo}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.grade}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.supervisor}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.vehicleNumber}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.transport}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* Pagination */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          itemsPerPage={itemsPerPage}
          totalItems={filteredData.length}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      </div>
    </div>
  );
};

export default Reports1;
